// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { IfFeature } from '@tectonics/prs/feature';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { FieldCustomerName } from './field-customer-name';
import { FieldCustomerEmail } from './field-customer-email';

import {
  FieldBrazilianDocument,
  FieldBrazilianPhoneNumber,
  BrazilianAddressGroup,
} from './brazilian';

import {
  FieldMexicanPhoneNumber,
} from './mexican';

import {
  FieldArgentineDocument,
  FieldArgentineDocumentType,
  FieldArgentinePhoneNumber,
  FieldArgentineCompanyName,
  FieldArgentineCuit,
  FieldArgentineCbu,
} from './argentine';

import {
  FieldColombianDocumentType,
  FieldColombianDocument,
  FieldColombianPhoneNumber,
} from './colombian';

import {
  FieldChileanDocument,
  FieldChileanPhoneNumber,
} from './chilean';

import {
  FieldPeruvianDocument,
  FieldPeruvianPhoneNumber,
} from './peruvian';

import {
  FieldUruguayanDocument,
  FieldUruguayanPhoneNumber,
} from './uruguayan';

import {
  FieldBolivianPhoneNumber,
} from './bolivian';

import {
  FieldEcuadorianDocument,
  FieldEcuadorianPhoneNumber,
} from './ecuador';

import {
  FieldPanamanianDocument,
  FieldPanamanianPhoneNumber,
} from './panamanian';

import {
  FieldGuatemalanDocument,
  FieldGuatemalanPhoneNumber,
} from './guatemalan';

import {
  FieldElSalvadorDocument,
  FieldElSalvadorPhoneNumber,
} from './el-salvador';

import {
  FieldDominicanDocument,
  FieldDominicanPhoneNumber,
} from './dominican';

import {
  FieldCostaRicanDocument,
  FieldCostaRicanPhoneNumber,
} from './costa-rican';

import {
  FieldParaguayanDocument,
  FieldParaguayanPhoneNumber,
} from './paraguayan';

import {
  FieldSouthAfricanPhoneNumber,
} from './south-african';

import {
  FieldKenyanPhoneNumber,
} from './kenyan/field-kenyan-phone-number';

import {
  FieldTanzanianPhoneNumber,
} from './tanzanian/field-tanzanian-phone-number';

import {
  FieldNigerianPhoneNumber,
} from './nigerian/field-nigerian-phone-number';

import {
  FieldIndiaPhoneNumber,
} from './india/field-india-phone-number';

import {
  FieldIndiaZipcode,
} from './india/field-india-zipcode';

import {
  FieldIndiaState,
} from './india/field-india-state';

import {
  FieldIndiaAddress,
} from './india/field-india-address';

import {
  FieldIndiaCity,
} from './india/field-india-city';

import {
  FieldIndiaStreetComplement,
} from './india/field-india-street-complement';

import {
  FieldIndiaStreetNumber,
} from './india/field-india-street-number';

import {
  FieldIndiaUpiApp,
} from './india/field-india-upi-app';

import {
  FieldUgandaPhoneNumber,
} from './uganda/field-uganda-phone-number';

import {
  FieldZambiaPhoneNumber,
} from './zambia/field-zambia-phone-number';

import {
  FieldEgyptPhoneNumber,
} from './egypt/field-egypt-phone-number';

import {
  FieldGhanaPhoneNumber,
} from './ghana/field-ghana-phone-number';


export function CustomerForm(): Node {
  const allFeatures = useCurrentAllFeatures();

  return (
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="field_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_document_type">
        <FieldColombianDocumentType />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_document">
        <FieldColombianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_customer_name">
        <FieldCustomerName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_nigerian_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_kenyan_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_tanzanian_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_south_african_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uganda_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_zambia_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_egypt_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_jamaican_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_document">
        <FieldBrazilianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_document">
        <FieldChileanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ecuadorian_document">
        <FieldEcuadorianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_document_type">
        <FieldArgentineDocumentType />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_document">
        <FieldArgentineDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_company_name">
        <FieldArgentineCompanyName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_cbu">
        <FieldArgentineCbu />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_cuit">
        <FieldArgentineCuit />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_document">
        <FieldPeruvianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uruguayan_document">
        <FieldUruguayanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_panamanian_document">
        <FieldPanamanianDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_guatemalan_document">
        <FieldGuatemalanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_el_salvador_document">
        <FieldElSalvadorDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_dominican_document">
        <FieldDominicanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_costa_rican_document">
        <FieldCostaRicanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_paraguayan_document">
        <FieldParaguayanDocument />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_kenyan_phone_number">
        <FieldKenyanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_nigerian_phone_number">
        <FieldNigerianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_tanzanian_phone_number">
        <FieldTanzanianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uganda_phone_number">
        <FieldUgandaPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_brazilian_phone_number">
        <FieldBrazilianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_mexican_phone_number">
        <FieldMexicanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_argentine_phone_number">
        <FieldArgentinePhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_peruvian_phone_number">
        <FieldPeruvianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_uruguayan_phone_number">
        <FieldUruguayanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_phone_number">
        <FieldColombianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_chilean_phone_number">
        <FieldChileanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_bolivian_phone_number">
        <FieldBolivianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ecuadorian_phone_number">
        <FieldEcuadorianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_panamanian_phone_number">
        <FieldPanamanianPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_guatemalan_phone_number">
        <FieldGuatemalanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_el_salvador_phone_number">
        <FieldElSalvadorPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_dominican_phone_number">
        <FieldDominicanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_costa_rican_phone_number">
        <FieldCostaRicanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_paraguayan_phone_number">
        <FieldParaguayanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_south_african_phone_number">

        <FieldSouthAfricanPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_phone_number">
        <FieldIndiaPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_zipcode">
        <FieldIndiaZipcode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_state">
        <FieldIndiaState />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_address">
        <FieldIndiaAddress />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_city">
        <FieldIndiaCity />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_street_complement">
        <FieldIndiaStreetComplement />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_street_number">
        <FieldIndiaStreetNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_india_upi_app">
        <FieldIndiaUpiApp />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_zambia_phone_number">
        <FieldZambiaPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_egypt_phone_number">
        <FieldEgyptPhoneNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ghana_customer_email">
        <FieldCustomerEmail />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_ghana_phone_number">
        <FieldGhanaPhoneNumber />
      </IfFeature>

      <BrazilianAddressGroup />
    </Root>
  );
}

const Root = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;

  & > * {
    grid-column: 1/3;
  }
`;
